import './NavBar.css'
import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useContext } from "react"
import { DomainContext } from '../../Context/Context';

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#212121',
        },
    },
  });

export const NavBar = () => {
	const { domainName, cloudName } = useContext(DomainContext)

	return (
		<Box sx={{ flexGrow: 1 }}>
			<ThemeProvider theme={darkTheme}>
				<AppBar position="fixed" top="0" color="primary" style={{backgroundImage: 'url("/img/banner.png")'}}>
					<Toolbar>
						<Box>
							{
								domainName === "Telecom" ?
									<img src="/logotelecom.png" alt="Telecom" style={{height:30,paddingLeft:1}}/>
								:
									<Typography
										variant="h4"
										component="div"
										paddingLeft={1}
									>
										{domainName}
									</Typography>
							}
						</Box>
						<Box sx={{display: "flex", justifyContent:"center", flexGrow: 1 }}>
						</Box>
						<Typography
							variant="h5"
							component="div"
							align="right"
						>
							Ayuda {cloudName}
						</Typography>
					</Toolbar>
				</AppBar>
			</ThemeProvider>
		</Box>
	);
};
